import React, { FunctionComponent, useMemo } from "react";

import { ColSpan, GridGapSize, GridLayout, GridLayoutAlignItems, GridLayoutItem, JustifySelf } from "@multiweb/reactComponents";
import { bemClassNames, EMPTY_ARRAY } from "@multiweb/reactUtils";
import { ParticipantType } from "@multiweb/types/multiweb";
import { RecordType } from "@multiweb/types/react";
import { DataRowTemplateComponentProps, getItems } from "../../../../components/DataRowTemplateComponent";
import { ParticipantsAttributes } from "../../../../types";

export type GridParticipantsRowTemplateComponentProps = DataRowTemplateComponentProps & {
    record?: RecordType;
};

const classNames = bemClassNames("grid-participants-row-template");

export const GridParticipantsRowTemplateComponent: FunctionComponent<GridParticipantsRowTemplateComponentProps> = ({
    dataSourceKey,
    recordId,
    contentDataSourceAttributeNames = EMPTY_ARRAY as string[],
    dataSourceAttributes,
    record,
}) => {
    const participantTypeIndex = contentDataSourceAttributeNames.indexOf(ParticipantsAttributes.participantType);
    const participantType = record?.[ParticipantsAttributes.participantType]?.value;

    const contentItems = useMemo(() => {
        const attributeNames: Readonly<string[]> = contentDataSourceAttributeNames.filter(item => {
            switch (item) {
                case ParticipantsAttributes.personName:
                    return participantType === ParticipantType.User || !record; // pro skeleton
                case ParticipantsAttributes.actualRoleName:
                    return participantType === ParticipantType.Role;
                case ParticipantsAttributes.name:
                    return true;
                default:
                    return false;
            }
        });

        return getItems(attributeNames, dataSourceKey, recordId, dataSourceAttributes);
    },
    [contentDataSourceAttributeNames, dataSourceKey, recordId, dataSourceAttributes, participantType, record]);

    const typeItem = useMemo(() => getItems([contentDataSourceAttributeNames[participantTypeIndex]], dataSourceKey, recordId, dataSourceAttributes),
        [contentDataSourceAttributeNames, participantTypeIndex, dataSourceKey, recordId, dataSourceAttributes]);

    return (
        <GridLayout alignItems={GridLayoutAlignItems.center} gap={GridGapSize.one} >
            <GridLayoutItem colSpan={ColSpan.ten} justifySelf={JustifySelf.start} width={"100%"}>
                <div className={classNames("content")}>
                    {contentItems}
                </div>
            </GridLayoutItem>
            <GridLayoutItem colSpan={ColSpan.two} justifySelf={JustifySelf.end}>
                <div className={classNames("type")}>
                    {typeItem}
                </div>
            </GridLayoutItem>
        </GridLayout>
    );
};
